import { useEffect, useState } from "react";
/* --------  intern functions -------- */
import { setTheme, setMainColor, updatePrefRequest } from "../../../store/actions";
/* -------- ------- -------- */

/* -------- packages -------- */
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
/* -------- ------- -------- */

export default function ThemeMode () {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const [menu, setMenu] = useState(false);
  
  const parameters = useSelector((state) => state.Parameters)
  const html = document.querySelector('html')

  const user = useSelector(state => state.Login.user);
  const userPref = user && typeof user.prefs === 'object' ? user.prefs : JSON.parse(user.prefs);

  function themeMode (theme) {
    
    if (parameters.theme != theme) {
      html.setAttribute('data-bs-theme', theme)
      document.body.setAttribute('data-sidebar', theme)
      
      let pref = {};
      
      if (user.prefs) {
        try {
          pref = typeof user.prefs === 'object' ? user.prefs : JSON.parse(user.prefs);
        } catch (e) {
          console.error('Error parsing user preferences:', e);
        }
      }
      
      const userPref = {
        prefs: {
          ...pref,
          themeMode: theme,
        }
      }
      
      dispatch(updatePrefRequest(user.id, userPref));
      dispatch(setTheme({ theme: theme}))
      
    } else {
      console.error('')
      }

  }


    useEffect(() => {
      if (userPref && userPref.themeMode) {
        html.setAttribute('data-bs-theme', userPref.themeMode)
        document.body.setAttribute('data-sidebar', userPref.themeMode)
        dispatch(setTheme({ theme: userPref.themeMode}))
      } else {
        html.setAttribute('data-bs-theme', parameters.theme)
        document.body.setAttribute('data-sidebar', parameters.theme)
      }
    }, []) 

    //className="btn header-item noti-icon position-relative"

  return (
    <>
        {html.getAttribute('data-bs-theme') == 'dark' ?
            <button type="button" className="btn header-item noti-icon position-relative" onClick={() => {themeMode('light')}} >
                <i className='bx bxs-sun themeIcon switch'></i>
            </button>
            :
            <button type="button" className="btn header-item noti-icon position-relative" onClick={() => {themeMode('dark')}}>
                <i className='bx bxs-moon themeIcon switch'></i>
            </button>
        }
    </>
  );
};